/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RuleConditionTypes {
    Equal = 10,
    ValueList = 20,
}
